import { Flex } from "@common/components/Flex";
import { I18n } from "react-redux-i18n";
import { getTestAttributes } from "@common/utils/tests";
import { MODULE_NAME } from "@modules/individuals";
import { FormControl } from "@common/components/form-control";
import { Tabs } from '@common/components/tabs';

import { TextEditor } from "@common/components/text-editor";

import "./email-template.styles.scss";

export const EmailTemplate = (props) => {
  const TAB_TYPE = {
    text: 'text',
    html: 'html',
  };
  const { template, onTemplateChange, subject, onSubjectChange } = props;
  const [currentTab, setCurrentTab] = React.useState(TAB_TYPE.html);
  const localModuleName = `${MODULE_NAME}-new-invite-email-template`;

  React.useEffect(() => {
    document.body.onselectstart = null;

    return () => {
      document.body.onselectstart = function () {
        return false;
      };
    };
  }, []);

  const handleTemplateBlur = React.useCallback(
    (e) => {
      const { value } = e.currentTarget;

      onSubjectChange(value);
    },
    [onSubjectChange]
  );

  const handleHtmlTextareaBlur = React.useCallback(
    (e) => {
      const { value } = e.currentTarget;

      onTemplateChange(value);
    },
    [onTemplateChange]
  );

  const tabs = React.useMemo(() => {
    return [
      {
        label: I18n.t('Text'),
        value: TAB_TYPE.text
      },
      {
        label: 'HTML',
        value: TAB_TYPE.html
      },
    ];
  }, []);

  const currentHtml = template || '<meta http-equiv="Content-Type" content="text/html; charset=utf-8"><title>Family History Questionnaire Invitation</title><table width="650" align="center" bgcolor="#ffffff"><tbody><tr><td><div align="center" style="color: #bbbbbb;font-family: Arial, Helvetica, sans-serif;font-size: 9px;"><br><img src="http://alpha.progenygenetics.com/logo.jpg" alt="Enable Images" align="absmiddle" width="210" height="43"></div><div align="justify" style="color: #666666;font-family: Arial, Helvetica, sans-serif;font-size: 13px;line-height: 150%;"><p>Dear&nbsp;{NAME},</p><p>Please take a few minutes to fill out our online Family History Questionnaire (FHQ). &nbsp;The FHQ will ask you about your personal and family history of cancer. &nbsp;It may help to talk with family members to gather information about their cancer diagnoses, types of cancer, ages of diagnosis etc. &nbsp;Once you start the questionnaire, you will be able to save it and come back later if needed. &nbsp;Please fill out the information the best that you can.</p></div><div align="center" style="font-family: Arial, Helvetica, sans-serif; font-weight: bold; font-size: 18px; text-align: center; text-decoration: none;"><font color="#0000ff"><a href="{LINK}">Click here to begin your Online Family History Questionnaire</a></font><br><br><div align="center" style="color: rgb(102, 102, 102); font-family: Arial, Helvetica, sans-serif; font-size: 17px; font-weight: bold; text-align: center;"><div align="center" style="color: #666666;font-family: Arial, Helvetica, sans-serif;font-size: 14px;text-align: center; font-style:italic; line-height: 100%; font-weight: bold;">If you have any questions, please contact us at:<br>Email: <a href="mailto:email@email.com">email@email.com</a><br>Phone: 555-555-5555</div></div></div></td></tr></tbody></table>';

  return (
    <div className="IndividualsEmailTemplate">
      <h6 className="IndividualsEmailTemplate__title">
        {I18n.t("Edit content of your email")}
      </h6>
      <Flex alignItems="center">
        <span className="IndividualsEmailTemplate__subject-label">
          {I18n.t("Email Subject")}
        </span>
        <FormControl
          {...getTestAttributes(localModuleName, 'subject-email', 'input')}
          className="IndividualsEmailTemplate__subject-input"
          defaultValue={subject}
          onBlur={handleTemplateBlur}
        />
      </Flex>
      <Tabs 
        value={currentTab}
        items={tabs}
        className="IndividualsEmailTemplate__tabs"
        onChange={setCurrentTab}
      />
      {currentTab === TAB_TYPE.html && (
        <TextEditor 
          classes={{
            workArea: 'IndividualsEmailTemplate__editor__work-area'
          }}
          className="IndividualsEmailTemplate__editor"
          defaultValue={currentHtml}
          onChange={onTemplateChange}
        />
      )}
      {currentTab === TAB_TYPE.text && (
        <textarea 
          defaultValue={currentHtml}
          className="IndividualsEmailTemplate__html-textarea"
          onBlur={handleHtmlTextareaBlur}
        />
      )}
    </div>
  );
};
